import { SingleInputConnectIntegrationFormModal } from '@modules/common/components/SingleInputConnectIntegrationFormModal';
import { IntegrationChannelType, IntegrationType } from 'generated/graphql';
import { useState } from 'react';

interface AppstoreFormModalProps {
  integrationType: IntegrationType;
}

export const AppstoreFormModal = ({
  integrationType,
}: AppstoreFormModalProps) => {
  const [appURL, setAppURL] = useState('');

  return (
    <SingleInputConnectIntegrationFormModal
      integrationType={integrationType}
      inputFieldData={appURL}
      setInputFieldData={setAppURL}
      channelType={IntegrationChannelType.Appstore}
      integrationData={{
        appstore: {
          appID: '',
          appName: '',
          appURL: appURL,
        },
      }}
      textFieldProps={{
        label: 'App URL',
        placeholder: 'Enter App URL',
      }}
    />
  );
};
